import React, { useState, useContext, Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Link as MyLookLink } from '../commonComponents';

import Item from './Item';
import Context from 'Components/context';
import { language, LANG_JP, LANG_KR, LANG_MY, LANG_HK, LANG_TH, LANG_TWQ, LANG_ARABIA_EN, LANG_ARABIA, LANG_RU, LANG_FIL } from 'Root/constants';
import { Hamburger } from 'Components/commonComponents';
import { LANG_VI } from 'Root/constants';
import { BuyModal, FreeTrialModal, ConfirmationModal } from 'Components/modal';
import HeaderConfig, {
  JapanHeaderConfig,
  KoreaHeaderConfig,
  VietnamHeaderConfig,
  HongkongHeaderConfig,
  MalaysiaHeaderConfig,
  ThailandHeaderConfig,
  TaiwanHeaderConfig,
  Arabia_EnHeaderConfig,
  ArabicHeaderConfig,
  RussiaHeaderConfig,
  IndonesiaHeaderConfig,
  PhilippinesHeaderConfig,
  AustraliaHeaderConfig
} from 'Root/configuration/Header';
import content from 'Content/content.json';
import * as Icons from 'Images/newUi/header';
import { CrossDomainHelper } from '../helper/CrossDomainLink';
import Image from '../commonComponents/image/Image';
import './navbar.scss';
import { LANG_AZ, LANG_ID } from '../../constants';

const {
  data: {
    buy: { [language]: buy },
    // freeTrial: { [language]: freeTrial },
    buy_pre_set: buyPresets,
  },
} = content;
const Navbar = () => {
  const { logout: logoutContext, lensKey } = useContext(Context);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [buyModal, setBuyModal] = useState(false);
  const [freeTrialModal, setFreeTrialModal] = useState(false);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const { items } =
    language === LANG_JP
      ? JapanHeaderConfig()
      : language === LANG_KR
      ? KoreaHeaderConfig()
      : language === LANG_MY
      ? MalaysiaHeaderConfig()
      : language === LANG_VI
      ? VietnamHeaderConfig()
      : language === LANG_HK
      ? HongkongHeaderConfig()
      : language === LANG_TH
      ? ThailandHeaderConfig()
      : language === LANG_TWQ
      ? TaiwanHeaderConfig()
      : language === LANG_ID
      ? IndonesiaHeaderConfig()
      : language === LANG_ARABIA_EN
      ? Arabia_EnHeaderConfig()
      : language === LANG_ARABIA
      ? ArabicHeaderConfig()
      : language === LANG_RU
      ? RussiaHeaderConfig()
      : language === LANG_FIL
      ? PhilippinesHeaderConfig()
      : language === LANG_AZ
      ? AustraliaHeaderConfig()
      : HeaderConfig();

  const { mobileItem } =
    language === LANG_JP
      ? JapanHeaderConfig()
      : language === LANG_KR
      ? KoreaHeaderConfig()
      : language === LANG_MY
      ? MalaysiaHeaderConfig()
      : language === LANG_HK
      ? HongkongHeaderConfig()
      : language === LANG_ID
      ? IndonesiaHeaderConfig()
      : language === LANG_TH
      ? ThailandHeaderConfig()
      : language === LANG_TWQ
      ? TaiwanHeaderConfig()
      : language === LANG_ARABIA_EN
      ? Arabia_EnHeaderConfig()
      : language === LANG_ARABIA
      ? ArabicHeaderConfig()
      : language === LANG_RU
      ? RussiaHeaderConfig()
      : language === LANG_FIL
      ? PhilippinesHeaderConfig()
      : language === LANG_AZ
      ? AustraliaHeaderConfig()
      : HeaderConfig();

  const showCamPopUp = (e) => {
    e.preventDefault();
    setConfirmationModal(true);
  };

  const hideCamPopUp = () => {
    setConfirmationModal(false);
    toggleMenu();
  };

  const onOpenBuy = () => {
    if (language === LANG_JP) {
      // const item = e.currentTarget.dataset.item; //Use item to switch between buy and freeTrial based upon region
      pathname.includes('/vm')
        ? window.open(
            CrossDomainHelper.coverToTrackingLinkInJP(
              buyPresets[lensKey],
              '_blank'
            )
          )
        : buy.length >= 0 &&
          window.open(
            CrossDomainHelper.coverToTrackingLinkInJP(buy[0].url, '_blank')
          );

      // If required, Else case will be to show Buy Modal containing url(buy->language->url) and Buy as title
    } else {
      setBuyModal(true);
    }
    toggleMenu();
  };

  const onOpenBuyOnly = () => {
    if (language === LANG_JP) {
      // const item = e.currentTarget.dataset.item; //Use item to switch between buy and freeTrial based upon region
      pathname.includes('/vm')
        ? window.open(
            CrossDomainHelper.coverToTrackingLinkInJP(
              buyPresets[lensKey],
              '_blank'
            )
          )
        : buy.length >= 0 &&
          window.open(
            CrossDomainHelper.coverToTrackingLinkInJP(buy[0].url, '_blank')
          );

      // If required, Else case will be to show Buy Modal containing url(buy->language->url) and Buy as title
    } else {
      setBuyModal(true);
    }
  };

  const onCloseBuy = () => setBuyModal(false);

  const onOpenFreeTrial = () => {
    setFreeTrialModal(true);
    toggleMenu();
  };

  const onOpenFreeTrialOnly = () => {
    setFreeTrialModal(true);
  }

  const onCloseFreeTrial = () => setFreeTrialModal(false);

  const toggleMenu = () => {
    if (window.innerWidth > 992) {
      setMenuOpen(false);
      return;
    }

    setMenuOpen(!isMenuOpen);
  };
  const logout = () => logoutContext();

  const onClickHandlers = {
    toggleMenu,
    showCamPopUp,
    onOpenBuy,
    onOpenBuyOnly,
    onOpenFreeTrial,
    onOpenFreeTrialOnly,
    logout,
  };
  const region = language === LANG_JP

  return (
    <header className={`header--wrapper${isMenuOpen ? ' overlay' : ''}`}>
      <section className="header--left logo--wrapper">
        {region && (
          <picture>
            <source
              media="(max-width: 992px)"
              srcSet={Icons.jpLogoMobileImage}
              alt="MyLook"
            />
            <img src={Icons.jpLogoImage} alt="MyLook" />
          </picture>
        )}
        {!region && (
          <Link
            to={{
              pathname: '/home',
            }}
            className="icons--site-logo"
            onClick={() => {
              isMenuOpen && toggleMenu();
            }}
          >
            <picture>
              <source
                media="(max-width: 992px)"
                srcSet={Icons.whitelogoImage}
                alt="MyLook"
              />
              <img src={Icons.logoImage} alt="MyLook" width="90" height="40"/>
            </picture>
          </Link>
        )}
        {mobileItem && (
          <MyLookLink
            className="icons--mobile__alone"
            onClick={onClickHandlers[mobileItem.onClick]}
            to={{
              pathname: mobileItem.href,
            }}
            href={mobileItem.href}
            target="_blank">
            <Image className="icons--mobile__alone-img" src={mobileItem.image} width="32" height="26"/>
          </MyLookLink>
        )}
        <Hamburger open={isMenuOpen} onClick={toggleMenu} />
      </section>

      <section className={`header--right${isMenuOpen ? ' show' : ' hide'}`}>
        <ul className={`lists${isMenuOpen ? ' show' : ' hide'}`}>
          {items.map(
            (
              {
                text,
                image,
                path = undefined,
                href = undefined,
                activeImage,
                share = undefined,
                onClick,
                condition = true,
                externalLink = undefined,
                additionalClass,
                subMenus = undefined
              },
              index
            ) => {
              if (condition) {
                const classname = additionalClass ? `lists--item ${additionalClass}` : `lists--item`;
                return (
                  // <li className={classname} key={index}>
                    <Item
                      text={text}
                      image={image}
                      href={href}
                      path={path}
                      activeImage={activeImage}
                      share={share}
                      location={pathname}
                      onClick={onClickHandlers[onClick]}
                      externalLink={externalLink}
                      subMenus={subMenus}
                      liClassName={classname}
                      key={index}
                    />
                  // </li>
                );
              }
            }
          )}
        </ul>
        {confirmationModal && (
          <ConfirmationModal notAllow={hideCamPopUp} modalType="camera" />
        )}
        {buyModal && <BuyModal onClose={onCloseBuy} />}
        {freeTrialModal && <FreeTrialModal onClose={onCloseFreeTrial} />}
      </section>
    </header>
  );
};

export default Navbar;
